import { Link } from "@tanstack/react-router";
import { BookOpen, Compass, Sparkles, Network, Sunrise, MessageCircle, NotebookPen, Bookmark, LayoutDashboard } from "lucide-react";

const items = [
  { to: "/academy", label: "Home", icon: Sparkles },
  { to: "/academy/library", label: "Library", icon: BookOpen },
  { to: "/academy/$domain", params: { domain: "human-design" }, label: "Bodygraph", icon: Compass },
  { to: "/academy/graph", label: "Graph", icon: Network },
  { to: "/academy/daily", label: "Daily", icon: Sunrise },
  { to: "/academy/ai-guide", label: "AI Guide", icon: MessageCircle },
  { to: "/academy/journal", label: "Journal", icon: NotebookPen },
  { to: "/academy/saved", label: "Saved", icon: Bookmark },
  { to: "/academy/dashboard", label: "Progress", icon: LayoutDashboard },
] as const;

export function AcademyNav() {
  return (
    <nav aria-label="Academy" className="border-b hairline bg-obsidian/60 backdrop-blur sticky top-0 z-30">
      <div className="mx-auto max-w-6xl overflow-x-auto px-4 sm:px-6">
        <ul className="flex min-w-max gap-1 py-2">
          {items.map((it) => {
            const Icon = it.icon;
            const linkEl = "params" in it
              ? (
                <Link to={it.to} params={it.params}
                  className="inline-flex min-h-11 items-center gap-2 rounded-full px-3 py-1.5 text-xs text-foreground/70 hover:text-gold hover:bg-white/5"
                  activeProps={{ className: "text-gold bg-white/5" }}>
                  <Icon size={14} /> {it.label}
                </Link>
              )
              : (
                <Link to={it.to}
                  className="inline-flex min-h-11 items-center gap-2 rounded-full px-3 py-1.5 text-xs text-foreground/70 hover:text-gold hover:bg-white/5"
                  activeProps={{ className: "text-gold bg-white/5" }}
                  activeOptions={{ exact: it.to === "/academy" }}>
                  <Icon size={14} /> {it.label}
                </Link>
              );
            return <li key={it.label}>{linkEl}</li>;
          })}
        </ul>
      </div>
    </nav>
  );
}
